'use client';

import { useMultiStepIndicator } from './MultiStepIndicatorContext';

export default function MultiStepIndicator() {
  const { currentStep, totalOfSteps } = useMultiStepIndicator();

  return (
    <nav aria-label="Progress" className="my-7 w-full md:w-1/2">
      <ol role="list" className="flex flex-row gap-3">
        {Array.from(new Array(totalOfSteps)).map((_, index) => (
          <li key={`step_indicator_${index}`} className="flex-1">
            {currentStep > index ? (
              <div className="rounded-md h-2 bg-primary-blue group transition-colors"></div>
            ) : currentStep === index ? (
              <div
                className="rounded-md h-2 bg-primary-blue"
                aria-current="step"
              ></div>
            ) : (
              <div className="rounded-md h-2 bg-gray-200 group transition-colors"></div>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
